module.exports = __webpack_public_path__ + "assets/ff9af975c5e31194156511bc071d4d86.mp3";